export default __webpack_public_path__ + "static/educational-initiative-0f6e98945a81efa5914ac1a215a32949.png";